import React, { useEffect, useState } from 'react';
import bgBanner from '../assets/images/bg-banner.png';
import { Helmet } from 'react-helmet';
import btnround from '../assets/images/btn-round.svg';
import homeaboutbanner from '../assets/images/home-about-banner.png';
import strategicallignment from '../assets/images/Strategic Alignment.png';
import endtoendsolution from '../assets/images/End-to-End Solutions.png';
import continuousimprovement from '../assets/images/Continuous Improvement.png';
import system from '../assets/images/system.svg';
import Navbar from '../components/Navbar';
import data from '../assets/images/data.svg';
import api from '../assets/images/api.svg';
import middleware from '../assets/images/middleware.svg';
import cloud from '../assets/images/cloud.svg';
import business from '../assets/images/business.svg';
import security from '../assets/images/security.svg';
import management from '../assets/images/management.svg';
import scalability from '../assets/images/scalability.svg';
import profile1 from '../assets/images/profile1.png';
import profile2 from '../assets/images/profile2.png';
import profile3 from '../assets/images/profile3.png';
import blog1 from '../assets/images/blog-1.png';
import arrowup from '../assets/images/arrow-up-right.svg';
import blog2 from '../assets/images/blog-2.png';
import blogavatar2 from '../assets/images/blog-avtar2.png';
import blog3 from '../assets/images/blog-3.png';
import blogavt3 from '../assets/images/blog-avtar3.png';
import connectionbanner from '../assets/images/connection-banner.png';
import Footer from '../components/Footer';
import '../styles/style.css';
import '../styles/particles.css';
import { Link } from 'react-router-dom';



function Home() {
//   const[beforeLoad,setBeforeLoad]= useState(true);
//  useEffect(() => {
//   setTimeout(()=>{
//     setBeforeLoad(false);
//   },1000);  
//  }, [])
  return (
   
      <>  
    {/* <!-- preloader --> */}
    {/* <div id="preloader">
      <div className="preloader">
        <span></span>
        <span></span>
      </div>
    </div> */}
    {/* <!-- preloader end  --> */}


     {/* <!-- Mouse Cursor Start -->   */}
     <div className="mouse-cursor cursor-outer"></div>
     <div className="mouse-cursor cursor-inner"></div>


    <header className="top-header" style={{background: `url(${bgBanner}) no-repeat top center`}}>
      <div id="particles-js"></div>
      <Navbar/>
      <section className="banner-caption flex-center">
        <div className="caption-header text-white">
          <div className="container text-center">
            <h1 className="caption-title home-title" data-aos="fade-up" data-aos-delay="100" data-aos-duration="1000"> Technology. Innovation. AI. </h1>
             <div className="animate-text d-none" ><h1 className="caption-title">
                        Technology. Innovation. AI.
                     </h1><h1 className="caption-title">
                        Technology. Innovation. AI.
                     </h1><h1 className="caption-title">
                        Technology. Innovation. AI.
                     </h1><h1 className="caption-title">
                        Technology. Innovation. AI.
                     </h1>
                     
                    </div> 
            <p className="col-lg-8 mx-auto caption-sub-title pe-lg-3 ps-lg-3 py-4 text-white" data-aos="fade-up" data-aos-delay="150" data-aos-duration="1500"> Empower your business with seamless technology integration, unlocking its full potential through cutting-edge solutions that drive efficiency, innovation, and growth. </p>
            
            <div data-aos="fade-up" data-aos-delay="200" data-aos-duration="2000">
            <Link to="/about" className="btn btn-gradient">
              <span className="pe-2">
                <img src={btnround} alt="Icon" />
              </span>More About Us </Link>
            </div>

              
          </div>
        </div>
      </section>
    </header>
    <section className="home-about light-gradient-bg py-5">
      <div className="container">
        <div className="row py-5">
          <div className="col-lg-6">
            <div className="column-left">
              <div className="title mb-5">
                <h1 className="section-title"> Entegation Technologies </h1>
              </div>
              <div className="column-left-content home-about-content">
                <p className="mb-0"> In today’s rapidly evolving digital landscape, the ability to integrate diverse technology systems is no longer a luxury—it’s a necessity. At Entegation, we are at the forefront of this technological revolution, dedicated to helping businesses like yours navigate the complexities of technology integration. Our mission is simple: to ensure that your technology infrastructure is not only functional but also strategically aligned with your business goals. <br />
                  <br /> Technology, when utilized correctly, can transform your organization, enabling you to achieve greater efficiency, productivity, and innovation. However, the challenge lies in ensuring that the various technology systems and platforms you rely on can communicate and work together seamlessly. This is where our expertise comes in. We specialize in integrating a wide range of technology solutions, from legacy systems to the latest in cloud computing, ensuring that your business operations run smoothly and effectively.
                </p>
                <Link to="/about" className="btn btn-theme mt-5">
                  <span className="pe-2">
                    <img src={btnround} alt="Icon" />
                  </span>Read More </Link>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="column-right">
              <div className="home-about-right d-flex justify-content-end">
                <img src={homeaboutbanner} alt="About-image" className="img-fluid" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="approach light-bg-column py-5">
      <div className="container">
        <div className="row py-5 gx-5">
          <div className="col-12 text-center">
            <div className="title mb-5">
              <h1 className="section-title mb-4">Our Approach</h1>
              <p className="section-title-sub mb-3"> Our approach to technology integration is centered around three key principles. </p>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="list-approach text-center">
              <div className="icon mb-5">
                <img src={strategicallignment} alt="Strategy-icon" />
              </div>
              <div className="column-title mb-4">
                <h1>Strategic Alignment</h1>
              </div>
              <div className="column-content">
                <p> We start by understanding your business objectives and challenges. This allows us to develop integration strategies that are not only technically sound but also aligned with your broader business goals. </p>
              </div>
            </div>
          </div>
          <div className="col-lg-4 border-sides">
            <div className="list-approach text-center">
              <div className="icon mb-5">
                <img src={endtoendsolution} alt="Solutions-icon" />
              </div>
              <div className="column-title mb-4">
                <h1>End-to-End Solutions</h1>
              </div>
              <div className="column-content">
                <p> From initial assessment to implementation and ongoing support, we provide end-to-end solutions that cover every aspect of technology integration. This ensures a seamless transition and minimizes disruptions to your operations. </p>
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="list-approach text-center">
              <div className="icon mb-5">
                <img src={continuousimprovement} alt="Growth-icon" />
              </div>
              <div className="column-title mb-4">
                <h1>Continuous Improvement</h1>
              </div>
              <div className="column-content">
                <p> Technology is constantly evolving, and so are we. We stay ahead of the curve, continuously updating our knowledge and skills to provide you with the most innovative and effective solutions available. </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="our-services radial-bg-block py-5">
      <div className="container">
        <div className="row py-5">
          <div className="col-12 text-center">
            <div className="title">
              <h1 className="section-title mb-4">Our Services</h1>
              <p className="section-title-sub"> We offer a comprehensive range of technology integration services, including: </p>
            </div>
          </div>
        </div>
        <div className="row gx-5">
          <div data-aos="fade-up" data-aos-delay="100" data-aos-duration="1000" className="col-lg-4">
            <div className="list-service">
              <div className="service-column text-center">
                <div className="icon-hover flex-center mb-3">
                  <img src={system} alt="System-icon" />
                </div>
                <div className="column-title mb-4">
                  <h1>System Integration</h1>
                </div>
                <div className="column-content service-desc">
                  <p> Connecting diverse software and hardware systems to work together seamlessly. </p>
                </div>
              </div>
            </div>
          </div>
          <div data-aos="fade-up" data-aos-delay="150" data-aos-duration="1500" className="col-lg-4">
            <div className="list-service">
              <div className="service-column text-center">
                <div className="icon-hover flex-center mb-3">
                  <img src={data} alt="System-icon" />
                </div>
                <div className="column-title mb-4">
                  <h1>Data Integration</h1>
                </div>
                <div className="column-content service-desc">
                  <p> Unifying data from various sources to provide a coherent view of your organization’s information. </p>
                </div>
              </div>
            </div>
          </div>
          <div data-aos="fade-up" data-aos-delay="200" data-aos-duration="2000" className="col-lg-4">
            <div className="list-service">
              <div className="service-column text-center">
                <div className="icon-hover flex-center mb-3">
                  <img src={api} alt="System-icon" />
                </div>
                <div className="column-title mb-4">
                  <h1>API Management</h1>
                </div>
                <div className="column-content service-desc">
                  <p> Developing and managing APIs to facilitate communication between different software applications. </p>
                </div>
              </div>
            </div>
          </div>
          <div data-aos="fade-up" data-aos-delay="100" data-aos-duration="1000" className="col-lg-4">
            <div className="list-service">
              <div className="service-column text-center">
                <div className="icon-hover flex-center mb-3">
                  <img src={middleware} alt="System-icon" />
                </div>
                <div className="column-title mb-4">
                  <h1>Middleware</h1>
                </div>
                <div className="column-content service-desc">
                  <p> Software that sits between different systems and facilitates their interaction. Middleware can handle tasks such as... </p>
                </div>
              </div>
            </div>
          </div>
          <div data-aos="fade-up" data-aos-delay="150" data-aos-duration="1500" className="col-lg-4">
            <div className="list-service">
              <div className="service-column text-center">
                <div className="icon-hover flex-center mb-3">
                  <img src={cloud} alt="System-icon" />
                </div>
                <div className="column-title mb-4">
                  <h1>Cloud Integration</h1>
                </div>
                <div className="column-content service-desc">
                  <p> Connecting on-premises systems with cloud-based services for greater flexibility and scalability. </p>
                </div>
              </div>
            </div>
          </div>
          <div data-aos="fade-up" data-aos-delay="200" data-aos-duration="2000" className="col-lg-4">
            <div className="list-service">
              <div className="service-column text-center">
                <div className="icon-hover flex-center mb-3">
                  <img src={business} alt="System-icon" />
                </div>
                <div className="column-title mb-4">
                  <h1>Business Process Integration</h1>
                </div>
                <div className="column-content service-desc">
                  <p> Aligning technology with your business processes to enhance efficiency and productivity. </p>
                </div>
              </div>
            </div>
          </div>
          <div data-aos="fade-up" data-aos-delay="100" data-aos-duration="1000" className="col-lg-4">
            <div className="list-service">
              <div className="service-column text-center">
                <div className="icon-hover flex-center mb-3">
                  <img src={security} alt="System-icon" />
                </div>
                <div className="column-title mb-4">
                  <h1>Security and Compliance</h1>
                </div>
                <div className="column-content service-desc">
                  <p> Aligning technology with your business processes to enhance efficiency and productivity. </p>
                </div>
              </div>
            </div>
          </div>
          <div data-aos="fade-up" data-aos-delay="150" data-aos-duration="1500" className="col-lg-4">
            <div className="list-service">
              <div className="service-column text-center">
                <div className="icon-hover flex-center mb-3">
                  <img src={management} alt="System-icon" />
                </div>
                <div className="column-title mb-4">
                  <h1>Change Management</h1>
                </div>
                <div className="column-content service-desc">
                  <p> Managing the transition to new systems and processes, including user training and support. </p>
                </div>
              </div>
            </div>
          </div>
          <div data-aos="fade-up" data-aos-delay="200" data-aos-duration="2000" className="col-lg-4">
            <div className="list-service">
              <div className="service-column text-center">
                <div className="icon-hover flex-center mb-3">
                  <img src={scalability} alt="System-icon" />
                </div>
                <div className="column-title mb-4">
                  <h1>Scalability and Flexibility</h1>
                </div>
                <div className="column-content service-desc">
                  <p> Designing integration solutions that can scale with the growth of the organization and adapt to new technologies or business needs. </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="center-caption py-5">
      <div className="container">
        <div className="row py-5">
          <div className="col-12">
            <div className="text-white pe-lg-5 ps-lg-5">
              <div className="caption-center-text">
                <h2 className="caption-text"> At Entegation Technologies LLC, we prioritize client satisfaction and understand the importance of staying ahead in a rapidly evolving tech landscape. Are you ready to transform your business through seamless technology integration? </h2>
                <Link to="/contact-us" className="btn btn-theme mt-5">
                  <span className="pe-2">
                    <img src={btnround} alt="Icon" />
                  </span>Contact us today </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="testimonial radial-bg-block py-5">
      <div className="container pt-5">
        <div className="row">
          <div className="col-12 text-center">
            <div className="title mb-5">
              <h1 className="section-title mb-4"> What Clients Say About Us </h1>
              <p className="section-title-sub mb-3 col-lg-7 col-12 mx-auto"> Don’t just take our word for it—hear from the businesses that have transformed their operations with our technology integration services: </p>
            </div>
          </div>
          {/* <!-- Carousel --> */}
          <div className="col-lg-12">
            <div id="testimonialCarousel" className="carousel slide" data-bs-ride="carousel">
              {/* <!-- Thumbnails for Testimonials --> */}
              <div className="col-lg-4 mx-auto thumbnail-container flex-center mt-4 mb-4">
                <img src={profile1} className="thumbnail" data-bs-slide-to="0" data-bs-target="#testimonialCarousel" alt="Person 1" width="80" height="80" />
                <img src={profile2} className="thumbnail" data-bs-slide-to="1" data-bs-target="#testimonialCarousel" alt="Person 2" width="80" height="80" />
                <img src={profile3} className="thumbnail" data-bs-slide-to="2" data-bs-target="#testimonialCarousel" alt="Person 3" width="80" height="80" />
              </div>
              <div className="carousel-inner">
                {/* <!-- First Testimonial --> */}
                <div className="carousel-item active">
                  <div className="testimonial-content">
                    <div className="row">
                      <div className="col-lg-12 text-center">
                        <div className="testimonial-text">
                          <blockquote className="blockquote">
                            <p> “Entegation has been a game-changer for our organization. Their ability to seamlessly connect our legacy systems with new technologies has dramatically improved our efficiency and data accuracy.” </p>
                          </blockquote>
                          <div className="fixed-rating">
                            <span className="star filled"></span>
                            <span className="star filled"></span>
                            <span className="star filled"></span>
                            <span className="star filled"></span>
                            <span className="star filled"></span>
                          </div>
                          <div className="profile-name mt-2">
                            <p className="mb-0"> Jenny Wilson <span className="ps-3">Grower.io</span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <!-- Second Testimonial --> */}
                <div className="carousel-item">
                  <div className="testimonial-content">
                    <div className="row">
                      <div className="col-lg-12 text-center">
                        <div className="testimonial-text">
                          <blockquote className="blockquote">
                            <p> “Entegation has been a game-changer for our organization. Their ability to seamlessly connect our legacy systems with new technologies has dramatically improved our efficiency and data accuracy.” </p>
                          </blockquote>
                          <div className="fixed-rating">
                            <span className="star filled"></span>
                            <span className="star filled"></span>
                            <span className="star filled"></span>
                            <span className="star filled"></span>
                            <span className="star filled"></span>
                          </div>
                          <div className="profile-name mt-2">
                            <p className="mb-0"> Jenny Wilson <span className="ps-3">Grower.io</span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <!-- Third Testimonial --> */}
                <div className="carousel-item">
                  <div className="testimonial-content">
                    <div className="row">
                      <div className="col-lg-12 text-center">
                        <div className="testimonial-text">
                          <blockquote className="blockquote">
                            <p> “Entegation has been a game-changer for our organization. Their ability to seamlessly connect our legacy systems with new technologies has dramatically improved our efficiency and data accuracy.” </p>
                          </blockquote>
                          <div className="fixed-rating">
                            <span className="star filled"></span>
                            <span className="star filled"></span>
                            <span className="star filled"></span>
                            <span className="star filled"></span>
                            <span className="star filled"></span>
                          </div>
                          <div className="profile-name mt-2">
                            <p className="mb-0"> Jenny Wilson <span className="ps-3">Grower.io</span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- Carousel controls (Next and Previous) --> */}
              <button className="carousel-control-prev" type="button" data-bs-target="#testimonialCarousel" data-bs-slide="prev">
                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Previous</span>
              </button>
              <button className="carousel-control-next" type="button" data-bs-target="#testimonialCarousel" data-bs-slide="next">
                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Next</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="count py-5" id="counter-section">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="count-list-section">
              <div className="counter-grid">
                <div className="counter-container text-center">
                  <div className="counter-item">
                    <div className="count-wrapper">
                      <h4 className="counter">
                        <span className="counterup">5</span>+
                      </h4>
                      <p>Project Done</p>
                    </div>
                  </div>
                  <p></p>
                </div>
                <div className="counter-container text-center">
                  <div className="counter-item">
                    <div className="count-wrapper">
                      <h4 className="counter">
                        <span className="counterup">150</span>+
                      </h4>
                      <p>Monthly Visitors</p>
                    </div>
                  </div>
                </div>
                <div className="counter-container text-center">
                  <div className="counter-item">
                    <div className="count-wrapper">
                      <h4 className="counter">
                        <span className="counterup">100</span>%
                      </h4>
                      <p>Focus on Client</p>
                    </div>
                  </div>
                </div>
                <div className="counter-container text-center">
                  <div className="counter-item">
                    <div className="count-wrapper">
                      <h4 className="counter">
                        <span className="counterup">10</span>+
                      </h4>
                      <p>Of In-Depth Experience</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section className="blog py-5">
      <div className="container">
        <div className="row">
          <div className="col-12 text-center">
            <div className="title mb-5">
              <h1 className="section-title mb-4">Read Our Blogs</h1>
              <p className="section-title-sub mb-3 col-7 mx-auto"> Stay updated with the latest trends, insights, and stories from the world of technology integration. </p>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-4">
            <div className="blog-container shadow">
              <div className="blog-banner card-image">
                <img src={blog1} alt="Blog banner" className="img-fluid blog-img" />
              </div>
              <div className="blog-content">
                <div className="blog-item-name">Design</div>
                <div className="blog-title py-3">
                  <h1> The Future of Enterprise Technology Integration </h1>
                </div>
                <div className="blog-body-content mb-3">
                  <p className="mb-0"> Explore how emerging technologies like AI and machine learning are shaping the future of enterprise technology. Discover how businesses can stay competitive by adopting these cutting-edge solutions. </p>
                </div>
                <Link to="/blogdetails" className="blog-link">Read More <span>
                    <img src={arrowup} alt="arrow-up" />
                  </span>
                </Link>
              </div>
              <div className="blog-footer d-flex pt-5 pb-2">
                <div className="profile me-3">
                  <img src={profile1} alt="Blog profile" className="img-fluid" />
                </div>
                <div className="profile-desc">
                  <p>Olivia Rhye</p>
                  <span className="blog-date">20 Jan 2022</span>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="blog-container shadow">
              <div className="blog-banner card-image">
                <img src={blog2} alt="Blog banner" className="img-fluid blog-img" />
              </div>
              <div className="blog-content">
                <div className="blog-item-name">Product</div>
                <div className="blog-title py-3">
                  <h1> Case Study: Successful <br />System Integration for a Global Retailer </h1>
                </div>
                <div className="blog-body-content mb-3">
                  <p className="mb-0"> Linear helps streamline software projects, sprints, tasks, and bug tracking. Here’s how to get started. </p>
                </div>
                <Link to="/blogdetails" className="blog-link">Read More <span>
                    <img src={arrowup} alt="arrow-up" />
                  </span>
                </Link>
              </div>
              <div className="blog-footer d-flex pt-5 pb-2">
                <div className="profile me-3">
                  <img src={blogavatar2} alt="Blog profile" className="img-fluid" />
                </div>
                <div className="profile-desc">
                  <p>Phoenix Baker</p>
                  <span className="blog-date">19 Jan 2022</span>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="blog-container shadow">
              <div className="blog-banner card-image">
                <img src={blog3} alt="Blog banner" className="img-fluid blog-img" />
              </div>
              <div className="blog-content">
                <div className="blog-item-name"> Software Engineering </div>
                <div className="blog-title py-3">
                  <h1> Top 5 Challenges in Data Integration and How to Overcome Them </h1>
                </div>
                <div className="blog-body-content mb-3">
                  <p className="mb-0"> Data integration can be complex, but with the right strategies, it’s possible to overcome common challenges. Read our guide on navigating the pitfalls and ensuring seamless data unification. </p>
                </div>
                <Link to="/blogdetails" className="blog-link">Read More <span>
                    <img src={arrowup} alt="arrow-up" />
                  </span>
                </Link>
              </div>
              <div className="blog-footer d-flex pt-5 pb-2">
                <div className="profile me-3">
                  <img src={blogavt3} alt="Blog profile" className="img-fluid" />
                </div>
                <div className="profile-desc">
                  <p>Lana Steiner</p>
                  <span className="blog-date">18 Jan 2022</span>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 text-center">
            <Link to="/blog" className="btn btn-theme mt-5">
              <span className="pe-2">
                <img src={btnround} alt="Icon" />
              </span>View More </Link>
          </div>
        </div>
      </div>
    </section>
    
    <section className="bottom-bg py-5">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="dark-bg-block">
              <div className="tech-integration d-flex align-items-center">
                <div className="col-lg-5">
                  <div className="contact-info-block text-white">
                    <h1>Start Your Transformation Today</h1>
                    <p className="py-4"> Let’s discuss how we can help you achieve seamless technology integration. </p>
                    <Link to="/contact-us" className="btn btn-theme">Contact Us Now</Link>
                  </div>
                </div>
                <div className="col">
                  <div className="connection-banner d-flex justify-content-end">
                    <img src={connectionbanner} alt="Integration banner" className="img-fluid" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    {/* <!-- footer --> */}
    <Footer/>
    <div className="progress-wrap">
      <svg className="progress-circle svg-content" width="100%" height="100%" viewBox="-1 -1 102 102">
        <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
      </svg>
    </div>
<Helmet>
<title>Entegation Technologies | Home</title>
<script src="https://cdn.jsdelivr.net/particles.js/2.0.0/particles.min.js"></script>
<script src="https://unpkg.com/aos@2.3.1/dist/aos.js" defer></script>
    <script src="assets/js/script.js" defer></script>
    <script src="assets/js/home.js" type="module" defer></script>
    <script src="assets/js/particles.js" type="module" defer></script>
    <script src="assets/js/app.js"  defer></script>
    <script src="assets/js/lib/stats.js" defer></script>
    <link to="https://unpkg.com/aos@2.3.1/dist/aos.css" rel="stylesheet" />
</Helmet>
    </>
    
    
  )
}

export default Home